import Fuse from "fuse.js";

// Adapted from https://github.com/krisk/Fuse/issues/235
function tokeniseStringWithQuotesBySpaces(string) {
    return string.match(/("[^"]*?"|[^"\s,]+)+(?=\s*|\s*$)/g) ?? [];
}

export function createFuseSearch(fuseOptions, returnRawResult = false) {
    let fuse;
    const cache = {
        input: null,
        result: [],
        hasNoData: true,
        dataset: [],
    };

    const indexMap = new Map();

    if (fuseOptions.keys === undefined)
        throw new Error("createFuseSearch: keys must be provided in the fuseOptions");

    return {
        setData(data) {
            fuse = new Fuse(data, {
                ...fuseOptions,
                ignoreLocation: true, // default False: True - to search ignoring location of the words.
                findAllMatches: true,
                shouldSort: true,
                includeScore: true,
            });
            cache.hasNoData = false;
            cache.dataset = data;
        },

        filterSort: field => (opt1, opt2) => {
            // Use fields if provided
            if (field) {
                const field1 = opt1.item[field];
                const field2 = opt2.item[field];

                if (field1 < field2)
                    return -1;
                if (field1 > field2)
                    return 1;
                return 0;
            }

            const idx1 = indexMap.get(opt1.value) ?? Infinity;
            const idx2 = indexMap.get(opt2.value) ?? Infinity;

            // folowing the order of search result, lower score better match
            return idx1 - idx2;
        },

        search(input) {
            if (cache.hasNoData)
                throw new Error("createFuseSearch: No data has been set!");

            if (cache.input !== input) {
                cache.input = input;

                const tokenisedSearchQuery = tokeniseStringWithQuotesBySpaces(input);

                if (tokenisedSearchQuery.length === 0) {
                    cache.result = returnRawResult ? cache.dataset : cache.dataset.map(res => res.id);
                }
                else {
                    indexMap.clear(); // clear map before new search

                    const fuseSearch = fuse.search({
                        $and: tokenisedSearchQuery.map(searchToken => {
                            // fuseOptions.keys => [{name: String, weight: int}]
                            const orFields = (fuseOptions.keys || [])
                                .map(option => option.name)
                                .map(key => ({ [key]: searchToken }));
                            return {
                                $or: orFields,
                            };
                        }),
                    }).sort((res1, res2) => res1.score - res2.score);

                    cache.result = returnRawResult ? fuseSearch : fuseSearch.map((res, idx) => {
                        indexMap.set(res.item.id, idx);

                        return res.item.id;
                    });
                }
            }

            return cache.result;
        },
    };
}
